import Portal = require("portal-gis");
import Base = require("./base-collection");
import Utils = require("../utils");

function convert(...v: any[]) {
    let nums = v.map(parseFloat);
    if (nums.some(isNaN)) return v;
    return nums;
}

function lt(v1, v2) {
    [v1, v2] = convert(v1, v2);
    return v1 < v2;
}

function gt(v1, v2) {
    [v1, v2] = convert(v1, v2);
    return v1 > v2;
}

function eq(v1, v2) {
    [v1, v2] = convert(v1, v2);
    return v1 == v2;
}

class Collection extends Base<Portal.MonikerSymbologyElement> {

    static about = `Symbology provides _findSymbol_ method to honor symbology filtering rules.`;

    findSymbol(symbolRule?: string, attrs = {}) {

        let symbols = this.models.map(m => m.data);
        let symbology: Portal.MonikerSymbologyElement;

        if(attrs.internalSymbology != undefined){
            symbolRule = attrs.internalSymbology;
        }

        symbology = symbolRule && Utils.first(symbols, m => m.id === symbolRule);
        if (!symbology) {
            console.warn("symbology rule not found, using default");
            symbology = Utils.first(symbols, m => m.id === "*");
            if (!symbology) {
                console.warn("symbology rule not found, using first rule");
                symbology = symbols[0];
            }
        }

        if (!symbology) {
            console.warn("no symbology rules!");
            return null;
        }

        let symbolIcon: Portal.MapIconConfigElement;

        attrs && symbology.Icons.filter(icons => !!icons.Filters.Filters.length).some(icon => {
            if (icon.Filters.Filters.every(filter => {
                // TODO: the name+value pair is limited, 
                // see about existing tools for representing mathematical expressions (e.g. http://mathjs.org/)
                //
                // id: field name, value: filter value, type: "simple"
                // currently supports simple comparisions but always "ands" each filter
                // vs
                // id: identifier, value: templated expression, type: "expression"
                // could support `sqrt(<%=population>/<%=area>)) * 100000`
                //
                // could do this via introducing "type" or just detecting a template (e.g. test for <%=)

                // allow comma separated values (for OR support)
                let values = Utils.split(filter.Value);

                // test each field, only one has to succeed
                return values.some(v => {
                    let startWith = v[0];
                    let value = Utils.data(attrs, filter.Name || filter.id);
                    switch (startWith) {
                        case "<":
                            return lt(value, Utils.rightOf(v, startWith));
                        case ">":
                            return gt(value, Utils.rightOf(v, startWith));
                        case "=":
                            return eq(value, Utils.rightOf(v, startWith));
                        default:
                            return value === v;
                    }
                });

            })) {
                symbolIcon = icon;
                return true;
            }
        });

        if (!symbolIcon) {
            symbolIcon = Utils.first(symbology.Icons, icons => icons.id === "*");
        }
        if (!symbolIcon) {
            console.warn("default symbol not defined, using first filter-free symbol");
            symbolIcon = Utils.first(symbology.Icons, icons => !icons.Filters.Filters.length);
        }
        if (!symbolIcon) {
            console.warn("no filter-free symbols exist, using first symbol");
            symbolIcon = symbology.Icons[0];
        }
        if (!symbolIcon) {
            console.warn("no symbols exist!");
            return null;
        }

        symbolIcon.template = symbolIcon.template || symbology.template;
        symbolIcon.Label = symbolIcon.Label || symbology.Label;
        return symbolIcon;
    }
}

export = Collection;